import { TableFilter } from "@/types/TableFilter";
import { TableView } from "@/types/TableView";

export function isViewChanged(
  activeView: TableView,
  allViews: TableView[],
  checkSurroundings?: boolean
) {
  if (activeView.name === "DEFAULT") return false;
  // id "DEFAULT" = ephemeral (ad-hoc / AI-applied) — nothing persistable
  // exists server-side, so it can never be "changed" relative to it. Named
  // ephemerals (e.g. the AI filter: name "AI", id "DEFAULT") would otherwise
  // diff against the seeded default entry and falsely read dirty.
  if (activeView.tableViewId === "DEFAULT") return false;

  const view = allViews.find((v) => v.tableViewId === activeView.tableViewId);

  if (!view) return false;

  if (checkSurroundings) {
    if (view.name !== activeView.name) return true;
    if (view.description !== activeView.description) return true;
  }

  return JSON.stringify(view) !== JSON.stringify(activeView);
}

export function isFilterChanged(
  activeFilter: TableFilter,
  allFilters: TableFilter[],
  checkSurroundings?: boolean
) {
  if (activeFilter.name === "DEFAULT") return false;
  // Same ephemeral exemption as isViewChanged — see comment there.
  if (activeFilter.tableFilterId === "DEFAULT") return false;

  const filter = allFilters.find(
    (f) => f.tableFilterId === activeFilter.tableFilterId
  );

  if (!filter) return false;

  if (checkSurroundings) {
    if (filter.name !== activeFilter.name) return true;
    if (filter.description !== activeFilter.description) return true;
  }

  return JSON.stringify(filter) !== JSON.stringify(activeFilter);
}

export function viewChanged(activeView: TableView, comparisonView: TableView) {
  return JSON.stringify(activeView) !== JSON.stringify(comparisonView);
}

export function filterChanged(
  activeFilter: TableFilter,
  comparisonFilter: TableFilter
) {
  return JSON.stringify(activeFilter) !== JSON.stringify(comparisonFilter);
}
